 import { useEffect, useState, useRef } from 'react'
import { useIdleTimer } from 'react-idle-timer/dist/index.legacy.esm.js'
import { Logout } from '../Logout'
import config from '../../../../config.json' 
import { useHistory } from 'react-router-dom';

 const timeout = config.Session_Timeout_Min * 60 * 1000;
 export default function IdleTimerContainer() {
  const [islogout, setIsLogout] = useState(false);
  const [sessionTimeoutMessage, setSessionTimeoutMessage] = useState('Your Session is Expired! Please Login Again');
  const lastActiveTimestampRef = useRef(localStorage.getItem('lastActiveTimestamp') || Date.now());
 const history = useHistory();
   const onIdle = () => {
    if (window.location.href.includes("/auth/login")) {
      return false; 
    }
    localStorage.setItem('sessionTimeoutMessage',sessionTimeoutMessage);
    setIsLogout(true);
    // history.push('/auth/login');
   }
 
   const {  reset, pause, resume } = useIdleTimer({
     onIdle,
     timeout
   })
 
 useEffect(() => {
    const storedTimestamp = localStorage.getItem('lastActiveTimestamp');
    if (storedTimestamp) {
      const elapsed = Date.now() - parseInt(storedTimestamp, 10);
      if (elapsed > timeout) {
        setIsLogout(true);
        localStorage.setItem('sessionTimeoutMessage',sessionTimeoutMessage);
      } else {
        resume();
        reset(timeout - elapsed);
      }
    } else {
      resume();
    }
  }, [reset, timeout, resume]);

  useEffect(() => {
    const handleUnload = () => {
     // console.log('Window or tab is closing');
      localStorage.setItem('lastActiveTimestamp', Date.now().toString());
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

 
   return (
     <>
       {islogout?<Logout />:''}
     </>
   )
 }
